module.exports = __webpack_public_path__ + "img/commentUser.ac182d91.jpg";